import { render, staticRenderFns } from "./menu2.vue?vue&type=template&id=cdc136a6&scoped=true"
import script from "./menu2.vue?vue&type=script&lang=js"
export * from "./menu2.vue?vue&type=script&lang=js"
import style0 from "./menu2.vue?vue&type=style&index=0&id=cdc136a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdc136a6",
  null
  
)

export default component.exports